/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Words mode reverses the order of words within the text and collapses whitespace to single spaces, while lines mode keeps each line exactly as written and only flips the top-to-bottom order of the lines.`)
};

const es_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El modo de palabras invierte el orden de las palabras dentro del texto y reduce los espacios en blanco a espacios individuales, mientras que el modo de líneas mantiene cada línea exactamente como está escrita e invierte solo el orden de arriba hacia abajo de las líneas.`)
};

const de_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Wörter-Modus kehrt die Reihenfolge der Wörter innerhalb des Textes um und reduziert Leerraum auf einzelne Leerzeichen, während der Zeilen-Modus jede Zeile exakt so belässt, wie sie geschrieben wurde, und nur die Reihenfolge der Zeilen von oben nach unten umkehrt.`)
};

const nl_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woorden modus keert de woordvolgorde in de tekst om en vouwt witruimte samen tot enkele spaties, terwijl lijnen modus elke lijn precies zoals geschreven houdt en alleen de van-boven-naar-beneden-volgorde van de lijnen omkeert.`)
};

const fr_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mode Mots inverse l'ordre des mots dans le texte et réduit les espaces blancs à des espaces simples, tandis que le mode Lignes garde chaque ligne exactement comme écrite et ne fait que retourner l'ordre de haut en bas des lignes.`)
};

const it_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La modalità Parole inverte l'ordine delle parole nel testo e comprime gli spazi bianchi in spazi singoli, mentre la modalità Righe mantiene ogni riga esattamente come scritta e capovolge solo l'ordine da alto a basso delle righe.`)
};

const pt_br2_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O modo Palavras inverte a ordem das palavras dentro do texto e reduz o espaço em branco para espaços únicos, enquanto o modo Linhas mantém cada linha exatamente como escrita e apenas inverte a ordem de cima para baixo das linhas.`)
};

const pt_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O modo Palavras inverte a ordem das palavras no texto e reduz espaços em branco a espaços únicos, enquanto o modo Linhas mantém cada linha exatamente como escrita e apenas inverte a ordem de cima para baixo das linhas.`)
};

const ja_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語モードはテキスト内の単語の順序を逆にし、空白を単一スペースに折りたたみます。一方、行モードは各行をそのまま保持し、行の上下順序のみを反転させます。`)
};

const zh_rv_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单词模式会反转文本中单词的顺序，并将空白字符压缩为单个空格；而行模式会保持每一行原样不变，只翻转各行从上到下的顺序。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_faq4_a", locale)
	if (locale === "en") return en_rv_faq4_a(inputs)
	if (locale === "es") return es_rv_faq4_a(inputs)
	if (locale === "de") return de_rv_faq4_a(inputs)
	if (locale === "nl") return nl_rv_faq4_a(inputs)
	if (locale === "fr") return fr_rv_faq4_a(inputs)
	if (locale === "it") return it_rv_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_rv_faq4_a(inputs)
	if (locale === "pt") return pt_rv_faq4_a(inputs)
	if (locale === "ja") return ja_rv_faq4_a(inputs)
	return zh_rv_faq4_a(inputs)
};